export default __webpack_public_path__ + "static/media/noasktasklist.96ca91fb.png";